import { createWebHistory, createRouter } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import LayoutView from "@/views/layout/LayoutView.vue";

import SearchView from "@/views/chat/SearchView.vue";
import ReportView from "@/views/chat/ReportView.vue";

import ForbiddenView from "@/views/error/ForbiddenView.vue";

import DocumentManagementView from "@/views/rag/DocumentManagementView.vue";
import DatabaseTableManagementView from "@/views/rag/DatabaseTableManagementView.vue";
import DatabaseMetaManagementView from "@/views/rag/DatabaseMetaManagementView.vue";
import FewShotManagementView from "@/views/rag/FewShotManagementView.vue";
import LegislationManagementView from "@/views/rag/LegislationManagementView.vue";
import CategoryManagementView from "@/views/rag/CategoryManagementView.vue";

//Token 확인
const requireAuth = () => (to, from, next) => {

    // HttpOnly 쿠키 전환으로 인해 Vuex에 토큰이 없으므로 localStorage의 draco-user-id 로 로그인 여부 임시 판별
    const userId = localStorage.getItem("draco-user-id");
    const bizYn = localStorage.getItem("bizYn");

    if (userId) {
        if (to.path === "/login") {
            if (bizYn == 'Y') {
                next("/main/biz");
            } else {
                next("/main");
            }

        } else if (to.path === "/") {
            if (bizYn == 'Y') {
                next("/main/biz");
            } else {
                next("/main");
            }

        } else {
            return next();
        }
    } else {
        next('/login');
    }
};

const toMain = () => (to, from, next) => {

    const userId = localStorage.getItem("draco-user-id");
    const bizYn = localStorage.getItem("bizYn");

    if (userId) {
        if (bizYn == 'Y') {
            next("/main/biz");
        } else {
            next("/main");
        }
    } else {
        return next();
    }
}

const routes = [
    {
        path: "/login",
        name: "LoginView",
        component: LoginView,
        beforeEnter: toMain()
    },
    {
        path: "/report",
        name: "report",
        component: ReportView,
        beforeEnter: requireAuth(),
    },
    {
        path: "/",
        component: LayoutView,
        beforeEnter: requireAuth(),
        children: [
            {
                path: "/main",
                name: "/main",
                component: SearchView
            },
            //오류
            {
                path: "/error/forbidden",
                name: "/error/forbidden",
                component: ForbiddenView
            },
            {
                path: "/search",
                redirect: "/main"
            },
            //RAG 관리
            {
                path: "/rag/documents",
                name: "DocumentManagementView",
                component: DocumentManagementView
            },
            {
                path: "/rag/database/tables",
                name: "DatabaseTableManagementView",
                component: DatabaseTableManagementView
            },
            {
                path: "/rag/database/meta",
                name: "DatabaseMetaManagementView",
                component: DatabaseMetaManagementView
            },
            {
                path: "/rag/database/few-shot",
                name: "FewShotManagementView",
                component: FewShotManagementView
            },
            {
                path: "/rag/database/legislation",
                name: "LegislationManagementView",
                component: LegislationManagementView
            },
            {
                path: "/rag/category",
                name: "CategoryManagementView",
                component: CategoryManagementView
            }
        ]
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;